const MessageIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    // biome-ignore assist/source/useSortedAttributes: <explanation>
<svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      stroke="white"
      {...props}
    >
      <title>message icon</title>
      <path
        d="M8.49951 18.998H7.99951C3.99951 18.998 1.99951 17.998 1.99951 12.998V7.99805C1.99951 3.99805 3.99951 1.99805 7.99951 1.99805H15.9995C19.9995 1.99805 21.9995 3.99805 21.9995 7.99805V12.998C21.9995 16.998 19.9995 18.998 15.9995 18.998H15.4995C15.1895 18.998 14.8895 19.148 14.6995 19.398L13.1995 21.398C12.5395 22.278 11.4595 22.278 10.7995 21.398L9.29951 19.398C9.13951 19.178 8.76951 18.998 8.49951 18.998Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M7.00049 7.99805H17.0005"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M7.00049 13.002H13.0005"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default MessageIcon;
